import KnowledgeBase from '@/pages/KnowledgeBase';

export default function MobileKnowledgeBaseScreen() {
  return <KnowledgeBase />;
}

